/* Automatic display requires verified offer settings. No beforeunload or back-button interception. */
(() => {
if (customElements.get('bc-welcome')) return;
class BCWelcome extends HTMLElement {
connectedCallback(){
 this.dialog=this.querySelector('dialog'); if(!this.dialog)return;
 this.abort=new AbortController();const signal=this.abort.signal;
 this.sessionKey='bcc:welcome-session';this.dismissKey='bcc:welcome-dismissed';this.joinedKey='bcc:welcome-joined';
 this.preview=new URLSearchParams(location.search).get('bc_popup_preview')==='1' || !!window.Shopify?.designMode;
 this.ready=this.dataset.ready==='true'&&this.dataset.codeReady==='true';
 this.originalFocus=null;this.previousOverflow='';this.opened=false;
 const get=(k)=>{try{return localStorage.getItem(k)}catch{return null}};
 this.blocked=!!get(this.joinedKey)||(Date.now()-Number(get(this.dismissKey)||0)<Number(this.dataset.cooldown||30)*864e5);
 try{this.blocked=this.blocked||sessionStorage.getItem(this.sessionKey)==='1'}catch{}
 this.querySelectorAll('[data-bc-close]').forEach(b=>b.addEventListener('click',()=>this.close(),{signal}));
 this.dialog.addEventListener('cancel',(e)=>{e.preventDefault();this.close()},{signal});
 this.dialog.addEventListener('click',(e)=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.close()}},{signal});
 this.querySelector('form')?.addEventListener('submit',(e)=>{if(!this.ready||this.preview)e.preventDefault()},{signal});
 if(this.preview){
  this.querySelector('[data-bc-preview-note]')?.removeAttribute('hidden');
  if(new URLSearchParams(location.search).get('bc_popup_step')==='success'){
   const form=this.querySelector('form'),template=this.querySelector('[data-bc-success-template]');
   if(form&&template){form.replaceChildren(template.content.cloneNode(true));this.querySelector('#bc-welcome-description').hidden=true;}
  }
 }
 this.querySelectorAll('[data-bc-copy]').forEach(button=>button.addEventListener('click',async()=>{
  const panel=button.closest('[data-bc-success]');const input=panel.querySelector('[data-bc-code]');const status=panel.querySelector('[data-bc-copy-status]');
  try{await navigator.clipboard.writeText(input.value);button.textContent='Copied';status.textContent='Code copied. Paste it at checkout.';}
  catch{input.focus();input.select();status.textContent='Your code is selected. Copy it, then paste it at checkout.';}
 },{signal}));
 if(this.querySelector('[data-bc-success]')){this.querySelector('#bc-welcome-title').textContent='Your 10% is ready.';this.querySelector('#bc-welcome-description').hidden=true;this.querySelector('.bc-welcome__eyebrow').textContent='Welcome to the Black Colt list';if(!this.preview){try{localStorage.setItem(this.joinedKey,'1')}catch{}}this.open(true);return}
 if(this.querySelector('[data-bc-error]')){this.open(true);return}
 this.addEventListener('shopify:section:select',()=>{if(window.Shopify?.designMode)this.open(true)},{signal});
 if(this.preview){this.open(true);return}
 if(!this.ready||this.blocked)return;
 this.activeMs=0;this.lastTime=performance.now();this.maxScroll=0;this.downScroll=0;this.upTravel=0;this.lastY=window.scrollY;
 this.interval=setInterval(()=>{const n=performance.now();if(!document.hidden)this.activeMs+=n-this.lastTime;this.lastTime=n},1000);
 document.addEventListener('mouseout',(e)=>{if(matchMedia('(pointer:fine)').matches&&!e.relatedTarget&&e.clientY<=0&&this.activeMs>=Number(this.dataset.desktopDelay||20)*1000&&this.downScroll>=120)this.open()},{signal});
 window.addEventListener('scroll',()=>{
 const y=window.scrollY;const delta=y-this.lastY;this.lastY=y;this.maxScroll=Math.max(this.maxScroll,y);this.downScroll+=Math.max(0,delta);
 this.upTravel=delta<0?this.upTravel-delta:0;
 const total=document.documentElement.scrollHeight-innerHeight;
 if(matchMedia('(pointer:coarse)').matches&&total>0&&this.maxScroll/total>=.5&&this.upTravel>=80&&this.activeMs>=Number(this.dataset.mobileDelay||45)*1000)this.open();
 },{passive:true,signal});
}
open(force=false){
 if(this.opened||this.dialog.open||(!force&&(this.blocked||!this.ready)))return;
 if(!force){
 const overlays=['dialog[open]','cart-drawer[open]','[aria-modal="true"]','#shopify-pc__banner'];
 if(overlays.some(s=>Array.from(document.querySelectorAll(s)).some(e=>e!==this.dialog&&e.getBoundingClientRect().height>0&&getComputedStyle(e).visibility!=='hidden'&&getComputedStyle(e).display!=='none')))return;
 if(document.activeElement?.matches('input,textarea,select'))return;
 }
 this.opened=true;this.originalFocus=document.activeElement;this.previousOverflow=document.documentElement.style.overflow;
 this.dialog.showModal();document.documentElement.style.overflow='hidden';
 if(!this.preview){try{sessionStorage.setItem(this.sessionKey,'1')}catch{}}
 this.querySelector('[data-bc-close]')?.focus();
}
close(){
 this.dialog.close();document.documentElement.style.overflow=this.previousOverflow;
 if(!this.preview){try{localStorage.setItem(this.dismissKey,String(Date.now()))}catch{}}
 if(this.originalFocus?.isConnected)this.originalFocus.focus();
}
disconnectedCallback(){this.abort?.abort();clearInterval(this.interval);if(this.dialog?.open){this.dialog.close();document.documentElement.style.overflow=this.previousOverflow}}
}
customElements.define('bc-welcome',BCWelcome);
})();
